import { Wizard } from "src/app/core/wizard/wizard";
import {  Injectable } from "@angular/core";
import { LocationAccessDeniedComponent } from "./location-access-denied/location-access-denied.component";

// new-popup-wizard.ts
@Injectable({
  providedIn: 'root'
})
export class locationAccessDeniedWizard extends Wizard<any> {
  key = 'location-denied';
  pageTypeMap = {
    'location-denied': LocationAccessDeniedComponent,
  };

  startingPageKey = 'location-denied';

  constructor() {
    super();

  }



}
